import React, { useState } from 'react';
import { DNAButton, DNABox, DNASlider, DNAHeader } from '@alucio/lux-ui';
import { DeviceMode, useAppSettings } from 'src/state/context/AppSettings';
import FAQScreen from 'src/screens/FAQ/FAQ';
import { generateZendeskURL } from 'src/utils/zendeskHelpers';
import useFeatureFlags from 'src/hooks/useFeatureFlags/useFeatureFlags';
type FAQButtonProps = { }

export const openKnowledgeBase = async (zendeskURL: string, deviceMode: DeviceMode, returnTo?: string) => {
  const url = await generateZendeskURL(zendeskURL, returnTo);
  if (deviceMode === DeviceMode.tablet) {
    window.location.assign(url);
  }
  else {
    window.open(url, '_blank');
  }
}

export const FAQButtonDesktop: React.FC<FAQButtonProps> = () => {
  const { isOnline }  = useAppSettings()
  const enableZendeskKnowledgebase = useFeatureFlags('enableZendeskKnowledgebase');
  const zenDeskURL = useFeatureFlags('BEAC_7431_dynamic_zendesk_url');
  const handlePress = async () => {
    if (isOnline && enableZendeskKnowledgebase) {
      openKnowledgeBase(zenDeskURL, DeviceMode.desktop);
    }
    else {
      window.open('/faq', '_blank');
    }
  }

  return (
    <DNAButton
      testID="user-guide-button"
      appearance="outline"
      status="tertiary"
      size="lg"
      iconLeft="question"
      onPress={handlePress}
    />
  )
}

export const FAQButtonTablet: React.FC<FAQButtonProps> = () => {
  const [visible, setVisible] = useState<boolean>(false)
  const { isOnline } = useAppSettings();
  const enableZendeskKnowledgebase = useFeatureFlags('enableZendeskKnowledgebase');
  const zendeskURL = useFeatureFlags('BEAC_7431_dynamic_zendesk_url');

  const handlePress = async () => {
    if (isOnline && enableZendeskKnowledgebase) {
      openKnowledgeBase(zendeskURL, DeviceMode.tablet);
    }
    else {
      setVisible(p => !p);
    }
  }

  return (
    <>
      <DNAButton
        testID="icon-help-circle-outline"
        appearance="ghost"
        status="subtle"
        size="xl"
        rounded
        iconLeft="question"
        onPress={handlePress}
      />
      <DNASlider
        visible={visible}
        setVisible={setVisible}
      >
        <DNABox
          fill
          appearance="col"
          style={{ backgroundColor: 'white' }}
        >
          <DNAHeader status="brand" title="User Guide / FAQ">
            <DNAHeader.Left>
              <DNAButton
                testID="tablet-header-close"
                status="secondary"
                onPress={() => setVisible(false)}
              >
                Close
              </DNAButton>
            </DNAHeader.Left>
          </DNAHeader>
          <FAQScreen />
        </DNABox>
      </DNASlider>
    </>
  )
}

type DeviceModeVariants = Record<DeviceMode, React.FC<FAQButtonProps>>
const deviceModeVariants:DeviceModeVariants = {
  desktop: FAQButtonDesktop,
  tablet: FAQButtonTablet,
}

export const FAQButton: React.FC<FAQButtonProps> = (props) => {
  const { deviceMode } = useAppSettings()
  const CurrentDeviceModeVariant = deviceModeVariants[deviceMode]
  return <CurrentDeviceModeVariant {...props}/>
}

export default FAQButton
